// extracted by mini-css-extract-plugin
export default {"control_box":"HeaderCartButton_control_box__pEmKH","cart_items_number":"HeaderCartButton_cart_items_number__XeZl+","cart_total":"HeaderCartButton_cart_total__9q4KH"};